export function DateFormat(date) {
    const newDate = new Date(date)
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }

    let formatedDate = newDate.toLocaleString('pt-BR', options)
    let returnDate = formatedDate.slice(0, 10) + ' - ' + formatedDate.slice(11)

    return returnDate
}

const DIAS_SEMANA = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];

export function calculaDataDiasUteis(diasUteis, dataInicio) {
    const data = new Date(dataInicio);
    let restante = Number(diasUteis);

    while (restante > 0) {
        data.setDate(data.getDate() + 1);
        const dia = data.getDay();
        if (dia !== 0 && dia !== 6) restante--;
    }

    const dataFormatada = data.toLocaleDateString('pt-BR');
    const nomeDia = DIAS_SEMANA[data.getDay()];
    return `${dataFormatada}, ${nomeDia}`;
}